import { Center, HStack, Progress } from "@chakra-ui/react";
import { OrderStatus } from "lib/api/enum";
import { getOrderStatusStepString } from "../string/getString";
import StepComponent from "./OrderStep";

interface OrderStepsProps {
    parcel: boolean;
    stepStatus: number;
}

const OrderStepStatusBar = (props: OrderStepsProps) => {
    const { parcel, stepStatus } = props;
    const stepAry = [
        OrderStatus.PICKUP,
        OrderStatus.PICKUP_COMPLETE,
        OrderStatus.MINTING,
        OrderStatus.MINT_COMPLETE,
        OrderStatus.SHIPPING,
    ];

    const statusBox = () => {
        return (
            <Center
                h="2.5rem"
                fontSize="0.813rem"
                fontWeight={"semibold"}
                border="1px"
                borderRadius={"sm"}
                borderColor="#eeeeee"
                bgColor={"#fafafa"}
                color={
                    stepStatus === OrderStatus.CANCEL_ORDER ||
                    stepStatus === OrderStatus.REJECT_ORDER
                        ? "#fc375f"
                        : stepStatus === OrderStatus.DELIVERY_COMPLETE
                        ? "#128cfe"
                        : "black"
                }
            >
                {getOrderStatusStepString(parcel, stepStatus!)}
            </Center>
        );
    };

    const getProgressValue = (step: OrderStatus) => {
        const maxV = stepAry.length - 1;
        const index = stepAry.findIndex((v) => v === step);
        return (100 / maxV) * index;
    };

    const stepProgress = () => {
        return (
            <HStack position={"relative"} h="2.5rem" justify={"space-between"}>
                {stepAry.map((step, index) => (
                    <StepComponent
                        key={`step_${index}`}
                        isParcel={parcel}
                        stepStatus={step}
                        active={stepStatus >= step}
                    />
                ))}
                <Progress
                    position={"absolute"}
                    top="0.43575rem"
                    left={"2.5%"}
                    right={"2.5%"}
                    h="2px"
                    colorScheme={"mint"}
                    value={getProgressValue(stepStatus)}
                    zIndex={0}
                />
            </HStack>
        );
    };
    return stepStatus > OrderStatus.CANCEL_ORDER &&
        stepStatus < OrderStatus.DELIVERY_COMPLETE
        ? stepProgress()
        : statusBox();
};

export default OrderStepStatusBar;
